import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { DEFAULT_VENUE_TYPE } from "../../lib/consts/venueTypes";
import { getDefaultVenuePath } from "../../lib/consts/navigation";

const VenueTypeRoute = ({ allowedVenueTypes = [], fallbackPath, children }) => {
  const navigate = useNavigate();
  const [, , , , , , , , , , , venueType] = useContext(UserContext);
  const currentVenueType = venueType || DEFAULT_VENUE_TYPE;
  const resolvedFallbackPath = fallbackPath || getDefaultVenuePath(currentVenueType);
  const isAllowed =
    allowedVenueTypes.length === 0 || allowedVenueTypes.includes(currentVenueType);

  // Redirigir en efecto (no con <Navigate>) evita desmontar una página pesada y montar
  // Navigate en el mismo commit — patrón que en producción dispara removeChild en react-dom.
  useEffect(() => {
    if (!isAllowed) {
      navigate(resolvedFallbackPath, { replace: true });
    }
  }, [isAllowed, navigate, resolvedFallbackPath]);

  if (!isAllowed) {
    return null;
  }

  return children;
};

export default VenueTypeRoute;
